export enum SettingsOption {
    /*
    SECTIONS = 'Secțiuni',
    PERMISIUNI = 'Permisiuni',
    PERMISIUNI_ACTIUNI = 'Acțiuni Permisiuni',
    FUNCTII = 'Funcții',
    */
    JUDET = 'Județe',
    REQUEST_TYPES = 'Tipuri Cereri',
    CERERE_PRIORITY = 'Prioritate Cerere',
    STATUS = 'Status Cerere',
    CERERE_SABLOANE = 'Șabloane Cereri',
    DOCUMENT_CATEGORY = 'Categorii Documente',
    DOCUMENT_TYPE = 'Tipuri Documente',
    DOCUMENT_TEMPLATE = 'Template Documente',
    REGISTRE = 'Registre',
    OPERATORI = 'Operatori',
    ZILE_LIBERE = 'Zile libere',
    /*
    PLATFORM_SECTION = 'Secțiuni Platformă',
    PLATFORM_FAQ = 'FAQ Platformă',
    PLATFORM_CONTENT = 'Conținut Platformă',
    PLATFORM_ANNOUNCES = 'Anunțuri Platformă',
    */
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}
